import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { NuqsAdapter } from "nuqs/adapters/react"

import * as ReactDOM from "react-dom/client"

import { HashRouter } from "react-router-dom"

import { App } from "./App"

// Create a client
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      console.error("Global query error:", query, error)
      // Optional: add your toast or logging here
    },
  }),
  defaultOptions: {
    queries: {
      retry: true,
      retryDelay: (attemptIndex) => {
        // Even faster for 429 errors, as they're expected to clear quickly
        const baseDelay = 1000 // Start at 1000ms
        const delay = Math.min(baseDelay * 1.3 ** attemptIndex, 3000) // Max 3 seconds

        // Small jitter to prevent all clients retrying simultaneously
        const jitter = delay * 0.1 * Math.random()

        console.log(
          `Global retry delay: ${Math.round(delay + jitter)}ms (attempt ${attemptIndex + 1})`,
        )
        return delay + jitter
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <HashRouter>
      <NuqsAdapter>
        <App />
      </NuqsAdapter>
    </HashRouter>
  </QueryClientProvider>,
)
